import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { fComp } from '../../utils/React.js';
import { BadgePresentation } from '../Badge/BadgePresentation.js';
import { IconLinkGroupWrapper } from '../IconLinkGroup/IconLinkGroupWrapper.js';
import './Headline.styles.js';

var defaultProps = {
  size: "h1",
  badgeLook: "primary",
  badgePosition: "overline"
};
var HeadlinePresentation = fComp(function (_ref) {
  var _cleanupClassObject, _cleanupClassObject2, _cleanupClassObject4, _cleanupClassObject5, _cleanupClassObject6, _cleanupClassObject8;
  var as = _ref.as,
    children = _ref.children,
    className = _ref.className,
    id = _ref.id,
    noMargin = _ref.noMargin,
    overline = _ref.overline,
    overlineAs = _ref.overlineAs,
    subline = _ref.subline,
    sublineAs = _ref.sublineAs,
    size = _ref.size,
    centeredLayout = _ref.centeredLayout,
    horizontalAlignment = _ref.horizontalAlignment,
    htmlAttrs = _ref.htmlAttrs,
    actions = _ref.actions,
    manualHyphenation = _ref.manualHyphenation,
    badgeText = _ref.badgeText,
    badgeIcon = _ref.badgeIcon,
    badgeLook = _ref.badgeLook,
    badgePosition = _ref.badgePosition;
  var HeadlineComponent = as || size;
  var OverlineComponent = overlineAs || "div";
  var SublineComponent = sublineAs || "div";
  var align = centeredLayout ? "center" : horizontalAlignment;
  var overlineBadge = badgePosition === "overline" && (badgeText && badgeText.trim() !== "" || badgeIcon);
  var sublineBadge = badgePosition === "subline" && (badgeText && badgeText.trim() !== "" || badgeIcon);
  var overlineRequired = overline || overlineBadge;
  var sublineRequired = subline || sublineBadge;
  var overlineSize = {
    h1: "large",
    h2: "large",
    h3: "large",
    h4: "small",
    h5: "small",
    h6: "small"
  }[size] || "small";
  var headlineGroup = /*#__PURE__*/React.createElement(React.Fragment, null, overlineRequired && /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, "".concat(lsgPre, "overline-container"), true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "overline-container__align-").concat(align), align), _cleanupClassObject))
  }, overline &&
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(OverlineComponent, {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(lsgPre, "overline"), true), _defineProperty(_cleanupClassObject2, "".concat(lsgPre, "overline-").concat(overlineSize), true), _defineProperty(_cleanupClassObject2, "".concat(lsgPre, "overline__hyphens-manual"), manualHyphenation), _cleanupClassObject2))
  }, overline), overlineBadge && /*#__PURE__*/React.createElement(BadgePresentation, {
    className: cleanupClassObject(_defineProperty({}, "".concat(lsgPre, "overline-badge"), true)),
    type: badgeText ? "text" : "icon",
    text: badgeText,
    icon: badgeIcon,
    look: badgeLook,
    size: "default"
  })), /*#__PURE__*/React.createElement(HeadlineComponent, Object.assign({}, htmlAttrs, {
    className: cleanupClassObject((_cleanupClassObject4 = {}, _defineProperty(_cleanupClassObject4, "".concat(lsgPre).concat(size), true), _defineProperty(_cleanupClassObject4, "".concat(className), !!className), _defineProperty(_cleanupClassObject4, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject4, "".concat(lsgPre, "headline__align-").concat(align), align), _defineProperty(_cleanupClassObject4, "".concat(lsgPre, "headline__hyphens-manual"), manualHyphenation), _cleanupClassObject4)),
    id: id
  }), children), sublineRequired && /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject5 = {}, _defineProperty(_cleanupClassObject5, "".concat(lsgPre, "subline-container"), true), _defineProperty(_cleanupClassObject5, "".concat(lsgPre, "subline-container__align-").concat(align), align), _cleanupClassObject5))
  }, subline &&
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(SublineComponent, {
    className: cleanupClassObject((_cleanupClassObject6 = {}, _defineProperty(_cleanupClassObject6, "".concat(lsgPre, "subline"), true), _defineProperty(_cleanupClassObject6, "".concat(lsgPre, "subline__hyphens-manual"), manualHyphenation), _cleanupClassObject6))
  }, subline), sublineBadge && /*#__PURE__*/React.createElement(BadgePresentation, {
    className: cleanupClassObject(_defineProperty({}, "".concat(lsgPre, "subline-badge"), true)),
    type: badgeText ? "text" : "icon",
    text: badgeText,
    icon: badgeIcon,
    look: badgeLook,
    size: "default"
  })));
  return /*#__PURE__*/React.createElement(React.Fragment, null, actions && /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject8 = {}, _defineProperty(_cleanupClassObject8, "".concat(lsgPre, "headline-action-group"), true), _defineProperty(_cleanupClassObject8, "".concat(lsgPre).concat(size, "-action-group"), true), _defineProperty(_cleanupClassObject8, "".concat(lsgPre, "headline-overline-action-group"), overline), _cleanupClassObject8))
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject(_defineProperty({}, "".concat(lsgPre, "action-group-headline-area"), true))
  }, headlineGroup), /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject(_defineProperty({}, "".concat(lsgPre, "action-group-action-area"), true))
  }, /*#__PURE__*/React.createElement(IconLinkGroupWrapper, {
    direction: "horizontal",
    className: cleanupClassObject(_defineProperty({}, "".concat(lsgPre, "no-margin"), true))
  }, actions))), !actions && /*#__PURE__*/React.createElement(React.Fragment, null, headlineGroup));
}, defaultProps);
HeadlinePresentation.displayName = "HeadlinePresentation";

export { HeadlinePresentation };
